import KSHeroSection from "./components/HeroSection";
import KSCitiesDirectory from "./components/CitiesDirectory";
import KSStateResources from "./components/StateResources";
import KSFAQSection, { faqs } from "./components/FAQSection";
import KSFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import CitySEOHead from "@/components/feature/CitySEOHead";

const kansasServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function KansasPage() {
  return (
    <>
      <CitySEOHead
        city="Kansas"
        state="Kansas"
        stateAbbr="KS"
        route="/states/kansas"
        title="Kansas Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Kansas — Wichita, Overland Park, Kansas City, Topeka, Lawrence, and Olathe. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Kansas, United States"
        geoPosition="38.5266;-96.7265"
        faqs={faqs.map((f) => ({ q: f.question, a: f.answer }))}
        servicesSchema={kansasServices}
      />
      <div className="font-sans">
        <KSHeroSection />
        <KSCitiesDirectory />
        <KSStateResources />
        <KSFAQSection />
        <SEOCrossLinks state="KS" />
        <KSFinalCTA />
      </div>
    </>
  );
}